module.exports = __webpack_public_path__ + "static/media/sc-logo.f3dd046e.jpg";